import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { HeaderComponent } from './components/header/header.component';
import { IonicModule } from '@ionic/angular';
import { PopoverListComponent } from './components/popover-list/popover-list.component';
import { RouterModule } from '@angular/router';
import { NavTabHeaderComponent } from './components/nav-tab-header/nav-tab-header.component';
import { LoaderComponent } from './components/loader/loader.component';
import { PaginationOptionsComponent } from './components/pagination-options/pagination-options.component';
import { AdvancedSearchComponent } from './components/advanced-search/advanced-search.component';
import { GroupSelectorComponent } from './components/group-selector/group-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GroupItemComponent } from './components/group-selector/group-item/group-item.component';
import { LoadGroupsEffects } from '@shared/effects/load-groups.effects';
import { StoreModule } from '@ngrx/store';
import * as fromUsers from '@features/users/reducers/users.reducer';
import * as fromCustomers from '@features/customers/admin/reducers/customers.reducer';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { MomentModule } from 'ngx-moment';
import { ResendEmailConfirmationEffects } from '@features/users/effects/resend-email-confirmation.effects';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { LoadGroupEffects } from '@shared/effects/load-group.effects';
import { MultiSelectComponent } from './components/multi-select/multi-select.component';
import { GroupDisplayComponent } from './components/group-display/group-display.component';
import { PeriodPipe } from './filters/period.pipe';
import { PurchaseTypePipe } from './filters/purchase-type.pipe';
import { ObfuscateValueComponent } from './components/obfuscate-value/obfuscate-value.component';
import { SetCartConfigEffects } from '@features/cart/effects/set-cart-config.effects';
import { GroupSelectorContainerComponent } from './components/group-selector-container/group-selector-container.component';
import { DiscountValueTypeComponent } from './components/discount-value-type/discount-value-type.component';
import { OrderSourcePipe } from './filters/order-source.pipe';
import { CreateCartEffects } from '@features/cart/effects/create-cart.effects';
import { SelectAddCustomerParentGroupEffects } from '@features/customers/admin/effects/select-add-customer-parent-group.effects';
import { UpdateCustomerEffects } from '@features/customers/admin/effects/update-customer.effects';
import { CreateCustomerEffects } from '@features/customers/admin/effects/create-customer.effects';
import { UserDisplayComponent } from './components/user-display/user-display.component';
import { EmojiFlagPipe } from './filters/emoji-flag.pipe';
import { ObserveElementDirective } from './directives/observe-element.directive';
import { EmailInputComponent } from './components/email-input/email-input.component';
import { ContactRolePipe } from './filters/contact-role.pipe';
import { PluralisePipe } from './filters/pluralise.pipe';
import { SendAgreementForSignaturesEffects } from './effects/send-agreement-for-signatures.effects';
import { SendAgreementForSignaturesComponent } from './components/send-agreement-for-signatures/send-agreement-for-signatures.component';
import { NumberPickerComponent } from './components/number-picker/number-picker.component';
import { OpportunityStagePipe } from './filters/opportunity-stage.pipe';
import { CustomEmailComponent } from './components/custom-email/custom-email.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { ChannelPipe } from './filters/channel.pipe';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { LastActivityPreviewComponent } from './components/last-activity-preview/last-activity-preview.component';
import { LeadSourcePipe } from './filters/lead-source.pipe';
@NgModule({
  declarations: [
    SideNavComponent,
    HeaderComponent,
    UserAvatarComponent,
    LastActivityPreviewComponent,
    PopoverListComponent,
    NavTabHeaderComponent,
    LoaderComponent,
    PaginationOptionsComponent,
    AdvancedSearchComponent,
    GroupSelectorComponent,
    GroupItemComponent,
    GroupSelectorContainerComponent,
    DatePickerComponent,
    NumberPickerComponent,
    EmptyStateComponent,
    MultiSelectComponent,
    PeriodPipe,
    ChannelPipe,
    GroupDisplayComponent,
    PurchaseTypePipe,
    ObfuscateValueComponent,
    DiscountValueTypeComponent,
    OrderSourcePipe,
    UserDisplayComponent,
    ObserveElementDirective,
    EmailInputComponent,
    PluralisePipe,
    SendAgreementForSignaturesComponent,
    OpportunityStagePipe,
    CustomEmailComponent,
    TooltipDirective,
    LeadSourcePipe,
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    ReactiveFormsModule,
    MomentModule,
    StoreModule.forFeature(fromUsers.featureKey, fromUsers.reducer),
    StoreModule.forFeature(fromCustomers.featureKey, fromCustomers.reducer),
    EffectsModule.forFeature([
      LoadGroupsEffects,
      LoadGroupEffects,
      ResendEmailConfirmationEffects,
      SetCartConfigEffects,
      CreateCartEffects,
      SelectAddCustomerParentGroupEffects,
      CreateCustomerEffects,
      UpdateCustomerEffects,
      SendAgreementForSignaturesEffects,
    ]),
    FormsModule,
    EmojiFlagPipe,
    ContactRolePipe,
  ],
  exports: [
    SideNavComponent,
    HeaderComponent,
    UserAvatarComponent,
    LastActivityPreviewComponent,
    PopoverListComponent,
    NavTabHeaderComponent,
    LoaderComponent,
    EmptyStateComponent,
    PaginationOptionsComponent,
    AdvancedSearchComponent,
    GroupSelectorComponent,
    GroupSelectorContainerComponent,
    DatePickerComponent,
    NumberPickerComponent,
    GroupDisplayComponent,
    PeriodPipe,
    ChannelPipe,
    ContactRolePipe,
    PurchaseTypePipe,
    ObfuscateValueComponent,
    DiscountValueTypeComponent,
    OrderSourcePipe,
    UserDisplayComponent,
    ObserveElementDirective,
    TooltipDirective,
    EmailInputComponent,
    PluralisePipe,
    OpportunityStagePipe,
    CustomEmailComponent,
    LeadSourcePipe,
  ],
})
export class SharedModule {}
